import userSignature from '../../../services/user-signature.service'

export default {
    async getUserSignature({ dispatch, commit }) {
        return await userSignature.getUserSignature()
          .then(response => {
            if (response.status || response.success) {
              const listUserSignature = response.data
              commit("SET_LIST_USER_SIGNATURE", listUserSignature)
              // dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
              return Promise.resolve(response.data);
            } else {
              dispatch("alertError", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            }
          }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
          })
      },

      async createUserSignature({ dispatch, commit }, data) {
        return await userSignature.createUserSignature(data)
          .then(response => {
            if (response.status || response.success) {
              dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
              return Promise.resolve(true);
            } else {
              dispatch("alertError", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            }
          }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
          })
      },

      async deleteUserSignature({ dispatch, commit }, params) {
        return await userSignature.deleteUserSignature(params)
          .then(response => {
            if (response.status || response.success) {
              dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
              return Promise.resolve(true);
            } else {
              dispatch("alertError", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            }
          }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
          })
      },

      async updateUserSignature({ dispatch, commit }, data) {
        return await userSignature.updateUserSignature(data)
          .then(response => {
            if (response.status || response.success) {
              dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
              return Promise.resolve(true);
            } else {
              dispatch("alertError", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
            }
          }).catch(error => {
            dispatch("alertError", error, { root: true });
            return Promise.reject(false);
          })
      },
}
